import { initializeApp } from "firebase/app";
/* eslint-disable no-console */

import { register } from 'register-service-worker'

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready () {
      console.log(
        'App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB'
      )
    },
    registered () {
      console.log('Service worker has been registered.')
    },
    cached () {
      console.log('Content has been cached for offline use.')
    },
    updatefound () {
      console.log('New content is downloading.')
    },
    updated () {
      console.log('New content is available; please refresh.')
    },
    offline () {
      console.log('No internet connection found. App is running in offline mode.')
    },
    error (error) {
      console.error('Error during service worker registration:', error)
    }
  })
}


// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyDEkNLDDyz7jWY_f3S4iHiQyJN2YdBRcIU",
    authDomain: "takin-61e75.firebaseapp.com",
    projectId: "takin-61e75",
    storageBucket: "takin-61e75.appspot.com",
    messagingSenderId: "232176365854",
    appId: "1:232176365854:web:1379f2ab3cb0b01b49190f",
    measurementId: "G-4NTP28E6PL", // 4. Get Firebase Configuration
}

// Initialize Firebase
export const app = initializeApp(firebaseConfig)
